import { Loader2 } from "lucide-react";

export const ScrollSentinel = ({ sentinelRef, loading, done, count, testid }) => (
  <div className="px-3 sm:px-6 py-8 flex justify-center" data-testid={testid}>
    {!done && <div ref={sentinelRef} className="h-1 w-full"/>}
    {loading && <Loader2 size={22} className="animate-spin text-[#00E7FF]" data-testid={`${testid}-loading`}/>}
    {done && count > 0 && <span className="text-xs text-white/40" data-testid={`${testid}-end`}>You're all caught up</span>}
  </div>
);
